<template>
  <a-form :form="form" @submit.prevent="onSubmit" layout="vertical">
    <a-form-item v-bind="errorsBind('non_field_errors')" />
    <a-row :gutter="16">
      <a-col :span="13">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item
              label="Imię"
              v-bind="errorsBind('first_name')"
              required
            >
              <a-input
                v-model="form.first_name"
                auto-complete="off"
                placeholder="imię"
              >
              </a-input>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item
              label="Nazwisko"
              v-bind="errorsBind('last_name')"
              required
            >
              <a-input
                v-model="form.last_name"
                auto-complete="off"
                placeholder="nazwisko"
              >
              </a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-form-item label="Email" v-bind="errorsBind('email')" required>
          <a-input
            type="email"
            v-model="form.email"
            auto-complete="off"
            disabled
            placeholder="adres email"
          >
          </a-input>
        </a-form-item>

        <a-button type="primary" html-type="submit" :disabled="!isDirty">
          <span>Zapisz</span>
        </a-button>
      </a-col>

      <a-col :span="7" :offset="2" class="mt-24">
        <avatar-input
          v-model="form.avatar"
          :currentUrl="form.avatar_preview"
          :action="avatarAction"
          @removeImage="form.avatar_preview = null"
        />
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import FieldsHelper from '@/components/common/forms/FieldsHelper'
import { Lecturer } from '@/api'
import AvatarInput from '@/components/inputs/AvatarInput'

export default {
  extends: FieldsHelper,
  components: {
    AvatarInput
  },
  computed: {
    avatarAction() {
      return Lecturer.attachmentUploadUrl + '?attachment_name=avatar'
    }
  }
}
</script>
